/**
 * Comparison Modal Component
 * Displays before/after comparison of AI-processed images
 */
import React from 'react';
import { Download, X } from 'lucide-react';

export function ComparisonModal({ 
  comparisonImages, 
  onDownload, 
  onClose 
}) {
  if (!comparisonImages?.original || !comparisonImages?.processed) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4">
      <div className="bg-[var(--surface)] rounded-xl max-w-6xl w-full max-h-[90vh] overflow-hidden">
        <div className="p-4 border-b border-[var(--border)] flex items-center justify-between">
          <h3 className="font-teko text-xl">Before & After Comparison</h3>
          <button 
            onClick={onClose} 
            className="p-2 hover:bg-[var(--background)] rounded-lg"
            data-testid="comparison-close-btn"
          >
            <X size={20} />
          </button>
        </div>
        <div className="p-4 grid md:grid-cols-2 gap-4">
          <div>
            <p className="text-sm text-[var(--text-secondary)] mb-2">Original</p>
            <img 
              src={comparisonImages.original} 
              alt="Original" 
              className="w-full rounded-lg"
            />
          </div>
          <div>
            <p className="text-sm text-[var(--text-secondary)] mb-2">Processed</p>
            <img 
              src={comparisonImages.processed} 
              alt="Processed" 
              className="w-full rounded-lg"
            />
          </div>
        </div>
        <div className="p-4 border-t border-[var(--border)] flex justify-end gap-2">
          <button 
            onClick={() => onDownload(comparisonImages.processed)} 
            className="px-4 py-2 bg-[var(--primary)] text-white rounded-lg flex items-center gap-2"
            data-testid="comparison-download-btn"
          >
            <Download size={16} /> Download
          </button>
          <button 
            onClick={onClose} 
            className="px-4 py-2 bg-[var(--background)] rounded-lg"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default ComparisonModal;
